module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5gSrf"))).then(() => parcelRequire('ljYL6'));